<template>
  <div class="options-form">
    <div class="options-form_block">
      <span class="options-form_title">Питание</span>

      <div class="options-form_block-inner">
        <div class="options-form_block-content">
          <div class="options-form_description">
            {{nutritionInfo.description}}
          </div>

          <div class="options-form_field-container">
            <div class="options-form_field-control">
              <ui-field label="Тип питания">
                <v-select
                  class="ui-select"
                  hide-details
                  solo
                  single-line
                  :menu-props="{ offsetY: true }"
                  v-model="nutritionValue"
                  :items="nutritionVariants"
                >
                  <template v-slot:prepend-inner>
                    <v-icon>$food</v-icon>
                  </template>
                </v-select>
              </ui-field>
            </div>

            <!-- <span class="options-form_field-price">
              Сумма: <span class="options-form_field-price-value">1000 р.</span>
            </span> -->
          </div>
        </div>

        <div class="options-form_slider">
          <!-- <ui-carousel
            class="ui-carousel--small"
            :slidesImg="[
              {src: '/static/images/image.jpg'}
            ]"
          >
          </ui-carousel> -->
        </div>
      </div>
    </div>

    <div class="options-form_block">
      <span class="options-form_title">Лечение</span>

      <div class="options-form_block-inner">
        <div class="options-form_block-content">
          <!-- <div class="options-form_description">
            Наши методики, проверенные временем, прекрасно помогают больным с остеохондрозом,
            спондилезом, ортрозом, межпозвоночными грыжами, патологическим кифозом и лордозом,
            радикулопатией, сколиозом, болезнью Бехтерева, остеопорозом и миозитом, различными
            видами артритов, во время реабилитации после переломов и травм.
          </div> -->

          <div class="options-form_field-container mb-6 hide-desktop">
            <div class="options-form_field-control">
              <ui-field label="Тип лечения">
                <v-select
                  class="ui-select"
                  hide-details
                  solo
                  single-line
                  :menu-props="{ offsetY: true }"
                  v-model="cureValue"
                  :items="cureItems"
                  item-text="title"
                  item-value="id"
                >
                  <template v-slot:prepend-inner>
                    <v-icon>$cure</v-icon>
                  </template>
                </v-select>
              </ui-field>
            </div>

            <!-- <span class="options-form_field-price">
              Сумма: <span class="options-form_field-price-value">1000 р.</span>
            </span> -->
          </div>
        </div>

        <div class="options-form_slider">
          <!-- <ui-carousel
            class="ui-carousel--small"
            :slidesImg="cureInfo.imgSet"
          >
          </ui-carousel> -->
        </div>
      </div>

      <cure-selection
        class="mb-10 hide-mobile"
        :nutrition-id="nutritionValue"
        :cure-id="cureValue"
        :guest-id="guestId"
        @change="changeCure"
      />

      <div class="options-form_block-additional">
        <div class="options-form_healthcard"
          v-if="isHealthcardAvilable(cureValue)"
        >
          <v-checkbox
            class="ui-checkbox"
            label="Оформить сан.-курортную карту на территории курорта Ключи"
            v-model="healthcardCheckboxValue"
          >
          </v-checkbox>

          <ui-field
            label="Кому"
            v-if="localHealthcardCheckboxValue"
            class="options-form_healthcard-select"
          >
            <v-select
              chips
              deletable-chips
              multiple
              class="ui-select"
              hide-details
              solo
              single-line
              :menu-props="{ offsetY: true }"
              :items="healthCardGuests"
              v-model="healthcardSelectValue"
            >
              <template v-slot:selection="{ item, index }">
                <v-chip
                  class="ui-chip"
                  v-if="index < 2"
                  close
                  @click:close="onHealthCardChipClose(item.value)"
                >
                  <span>{{ item.text }}</span>
                </v-chip>

                <v-chip
                  class="ui-chip"
                  v-if="index === 2"
                >
                  <span class="ui-chip_text">еще {{ healthcardSelectValue.length - 2 }}</span>
                </v-chip>
              </template>
            </v-select>
          </ui-field>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapState, mapGetters, mapActions, createLogger} from 'vuex'
import UiField from './UI/UiField.vue'
import CureSelection from "@/components/CureSelection.vue"
import Functions from '@/helpers/Functions';

export default {
  components: {UiField, CureSelection},
  name: '',

  props: {
    guestId: {
      type: Number,
      default: null,
    },
  },

  data: () => ({
    isSingletone: 0,
    localHealthcardCheckboxValue: false,
  }),

  methods:{
    ...mapActions({
      updateAllGuests: 'guestsModule/updateAllGuests',
      updateGuest: 'guestsModule/updateGuest',
      updateCommonFields: 'guestsModule/updateCommonFields',
      // storeCalcGuestPrice: 'guestsModule/calcGuestPrice',
    }),

    onHealthCardChipClose(id) {
      this.healthcardSelectValue = this.healthcardSelectValue.filter(item => item !== id)
    },

    isHealthcardAvilable(cureId) {
      return ['29'].indexOf(cureId) === -1
    },

    changeCure(cureId) {
      this.cureValue = cureId
    }
  },

  computed: {
    ...mapState({
      storeDefaults: store => store.selection.defaults,
      isSpaTour: store => store.selection.isSpaTour,
      daysCnt: store => store.selection.daysCnt,
    }),

    ...mapGetters({
      selectedCategoryData: 'selection/getSelectedCategory',
      getNutritionItems: 'dictionaries/getNutrition',
      getNutritionItemById: 'dictionaries/getNutritionById',
      getCureList: 'dictionaries/getCureList',
      getHealthTour: `dictionaries/getHealthTour`,
      getGuestField: 'guestsModule/getGuestField',
      getCommonField: 'guestsModule/getCommonField',
      getFilteredGuestsFields: 'guestsModule/getFilteredGuestsFields',
    }),

    guestAge() {
      const birthday = this.getGuestField(this.guestId, 'birthday');
      return Functions.calcAge(birthday)
    },

    nutritionVariants() {
      let list = this.getNutritionItems

      // если есть флаг spaTour, то лечение только СПА, питание только шведский стол
      if(this.isSpaTour) {
        if(+this.selectedCategoryData.divisionId === 2) {
          list = list.filter(obj => +obj.value === 2)
        } else {
          const spaNutritionIds = [`1`, `5`]
          list = list.filter((obj) => spaNutritionIds.findIndex((i) => i === String(obj.value)) !== -1)
        }
      } else {
        // у категорий кр.яра только заказное питание
        if(+this.selectedCategoryData.divisionId === 2) {
          list = list.filter(obj => +obj.value === 2)
        }
      }

      // Если коррекция веса, то в селекте вариантов питания только заказное
      if(+this.cureValue === 30 || +this.cureValue === 32) {
        list = list.filter(obj => +obj.value === 2)
      }
      return list
    },

    nutritionValue: {
      get() {
        let value = null
        if(this.isSingletone) {
          value = this.getCommonField('nutrition')
        } else {
          value = this.getGuestField(this.guestId, 'nutrition')
        }
        return value
      },
      set(value) {
        let updateObj = {
          nutrition: value,
        }

        if(this.isSingletone) {
          this.updateAllGuests(updateObj)
          this.updateCommonFields(updateObj)
        } else {
          this.updateGuest({
            id: this.guestId,
            obj: updateObj,
          })
        }
      }
    },

    nutritionInfo() {
      let obj = this.getNutritionItemById(this.nutritionValue)
      return {
        description: obj.description,
        imgSet: obj.images,
      }
    },

    cureItems() {
      const guestType = this.getGuestField(this.guestId, 'guestType')
      const availableForKids = [`1`, `3`, `21`, `32`, `33`]
      const availableForRetiree = [`3`, `35`, `2`,`36`,`33`]
      const unavilableForAdult = [`21`]

      let cureHealthBxId = this.getHealthTour.kluchiBxId;

      if(+this.selectedCategoryData.divisionId === 2) {
        cureHealthBxId = this.getHealthTour.krYarBxId
      }

      if(cureHealthBxId) {
        availableForKids.push(String(cureHealthBxId))
      }

      const res = this.getCureList
      if(guestType === `1`) {
        return res.filter(i => availableForKids.findIndex(y => +i.btrId === +y) !== -1)
      } else if(this.guestAge > 69 && this.daysCnt > 9) {
        return res.filter(i => availableForRetiree.findIndex(y => +i.btrId === +y) !== -1)
      } else {
        return res.filter(i => unavilableForAdult.findIndex(y => +i.btrId === +y) === -1)
      }
    },

    cureValue: {
      get() {
        let value = null
        if(this.isSingletone) {
          value = this.getCommonField('cure')
        } else {
          value = this.getGuestField(this.guestId, 'cure')
        }

        return value
      },
      set(value) {
        let updateObj = {
          cure: value,
        }

        // Если коррекция веса, то поле питание - заказное
        if(+value === 30 || +value === 32) {
          updateObj.nutrition = '2'
        }

        if(this.isSingletone) {
          this.updateAllGuests(updateObj)
          this.updateCommonFields(updateObj)

          if(!this.isHealthcardAvilable(value)) {
            this.updateAllGuests({ healthcard: null, })
          }
        } else {
          this.updateGuest({
            id: this.guestId,
            obj: updateObj,
          })

          if(!this.isHealthcardAvilable(value)) {
            this.updateGuest({
              id: this.guestId,
              obj: { healthcard: null, },
            })
          }
          // this.storeCalcGuestPrice(this.guestId)
        }
      }
    },

    healthcardCheckboxValue: {
      get() {
        let value = null
        if(this.isSingletone) {
          value = this.localHealthcardCheckboxValue
        } else {
          value = this.getGuestField(this.guestId, 'healthcard')
        }
        return value
      },
      set(value) {
        if(this.isSingletone) {
          this.localHealthcardCheckboxValue = value
        } else {
          this.updateGuest({
            id: this.guestId,
            obj: { healthcard: value, },
          })

          // this.storeCalcGuestPrice(this.guestId)
        }
      }
    },

    healthcardSelectValue: {
      get() {
        return this.getFilteredGuestsFields(
          [ 'id', ],
          { healthcard: true }
        ).reduce((acc, cur) => {
          acc.push(cur.id)
          return acc
        }, [])
      },
      set(selectedArr) {
        this.updateAllGuests({healthcard: false})

        // исскуственная задержка для правильного  перерасчета стоимости
        setTimeout(() => {
          selectedArr.forEach(id => {
            this.updateGuest({
              id: id,
              obj: {
                healthcard: true,
              },
            })
          })
        }, 100)

      }
    },

    healthCardGuests() {
      return this.getFilteredGuestsFields([
        'id',
        'firstName',
        'secondName',
        'thirdName',
        'guestType',
      ]).reduce((acc, cur) => {
        if(cur.guestType === '2') return acc
        let temp = {
          text: `${cur.secondName} ${cur.firstName.substring(0,1)}. ${cur.thirdName ? cur.thirdName.substring(0,1)+'.' : ''}`,
          value: cur.id
        }
        acc.push(temp)

        return acc
      }, [])
    }
  },

  watch: {
    localHealthcardCheckboxValue(newVal) {
      if(newVal === false && this.healthcardSelectValue.length > 0) {
        this.updateAllGuests({healthcard: false})
      }
    },
  },

  created() {
    if(!this.guestId) {
      this.isSingletone = 1
      this.localHealthcardCheckboxValue = this.getFilteredGuestsFields(
        [ 'id', ],
        { healthcard: true }
      ).length > 0 ? true : false
    }
  },
}
</script>

<style lang="sass">
.options-form_block

  + .options-form_block
    margin-top: 40px
    padding-top: 40px
    border-top: 1px solid #8A8A8A

.options-form_title
  display: block
  margin-bottom: 20px
  font-weight: 700
  font-size: 1.125em
  color: #1A4745

.options-form_block-inner
  width: 100%
  display: flex

.options-form_block-content
  min-width: 1px
  flex-grow: 1

.options-form_description
  margin-bottom: 35px

.options-form_field-container
  width: 100%
  display: flex
  align-items: flex-end
  justify-content: space-between

.options-form_field-control
  flex-grow: 1
  max-width: 440px

.options-form_field-price-value
  font-weight: 900

.options-form_healthcard-select
  max-width: px-em(440)


.options-form_slider
  width: 285px
  flex-shrink: 0
  margin-left: px-em(40)

.options-form_block-additional
  min-height: 46px

.ui-checkbox
  margin-top: 0 !important
  padding-top: 0

.hide-desktop
  display: none

@media screen and (max-width: $mobile-breakpoint)
  .options-form_block
    + .options-form_block
      padding-top: px-em(20,12)
      margin-top: px-em(20,12)

  .options-form_block-inner
    flex-direction: column

  .options-form_title
    margin-bottom: px-em(10,12)

  .options-form_description
    margin-bottom: px-em(20,12)

  .hide-desktop
    display: block

  .hide-mobile
    display: none
</style>
